/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

import ScrollLockController from 'scripts/marmalade/classes/scroll-locker';

/*------------------------------------------------------------------
Scroll Direction
------------------------------------------------------------------*/

let y = 0;
let dir = '';
const updateAttribute = direction => {
  if (dir == direction) return;
  document.documentElement.setAttribute('data-scrolldir', direction);
  dir = direction;
};
const updateDirection = () => {
  updateAttribute(window.scrollY > y ? 'down' : 'up');
  y = window.scrollY;
};
window.addEventListener('scroll', updateDirection, {
  passive: true
});

/*------------------------------------------------------------------
Scroll Controller
------------------------------------------------------------------*/

window.ScrollLocker = new ScrollLockController(document.querySelector('.body'));
window.ScrollLocker.on('unlock', () => {
  // set a data attribute on the html
  setTimeout(() => {
    document.documentElement.setAttribute('data-scrolldir', 'up');
  }, 50);
});
window.ScrollLocker.on('lock', () => {
  // set a data attribute on the html
  setTimeout(() => {
    document.documentElement.setAttribute('data-scrolldir', 'down');
  }, 50);
});

/*------------------------------------------------------------------
Scroll to links
------------------------------------------------------------------*/

const getCenteredOffset = element => {
  // Get the bounds of the element
  const elementBounds = element.getBoundingClientRect();
  // Get the element height
  const elementHeight = element.clientHeight;
  // Get the window height
  const windowHeight = window.innerHeight;

  // Get the offsetTop of the element
  const elementPageY = elementBounds.top + window.scrollY;

  // Get the element center Y
  const elementCenterY = elementPageY + elementHeight / 2;

  // Get the window center Y
  const windowCenterY = windowHeight / 2;

  // Get the offset to center the element in the viewport
  let offsetY = elementCenterY - windowCenterY;
  return offsetY;
};
function getTargetElement(hash) {
  const target = document.getElementById(hash.replace('#', ''));
  return target ? target.firstElementChild || target : null;
}

// Watch for new links on the page
DomObserver.observe('a', links => {
  links.forEach(link => {
    if (link.hash) {
      // Add the click event listener
      link.addEventListener('click', e => {
        const element = getTargetElement(link.hash);
        console.log('element', link.hash);
        if (link.hash === '#Main') return;

        // Prevent the default behavior

        if (element) {
          e.preventDefault();
          // Scroll to the element
          window.ScrollController.scrollTo(getCenteredOffset(element));
        }
      });
    }
  });
});
document.body.scrollTo(0, 0);
window.scrollToHash = function () {
  let fromTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const element = getTargetElement(window.location.hash);
  if (element) {
    if (fromTop) window.scrollTo(0, 0);
    setTimeout(() => {
      window.ScrollController.scrollTo(getCenteredOffset(element));
    }, 100);
  }
};

// If there is a hash in the URL
if (window.location.hash) {
  scrollToHash(true);
}